import { SettingConst } from '@faire/web-api--source/types';

/**
 * Controls experience for Visual Navigation Updates
 */
export const ENABLE_VISUAL_NAVIGATION_UPDATE_XP_250313 =
  'ENABLE_VISUAL_NAVIGATION_UPDATE_XP_250313' as SettingConst<
    'ENABLE_VISUAL_NAVIGATION_UPDATE_XP_250313',
    boolean,
    'RETAILER'
  >;
